// zh_CN.js
import gameLang from './lang/game';
import addLang from './lang/add';
import subscribeLang from './lang/subscribe';
import settingLang from './lang/setting';
import commonLang from './lang/common';
const getLang = (obj, prefix) => {
  let tempObj = {};
  Object.keys(obj).forEach(key => {
    if (prefix) {
      tempObj = Object.assign(tempObj, { [`${prefix}_${key}`]: obj[key][1] });
    } else {
      tempObj = Object.assign(tempObj, { [key]: obj[key][1] });
    }
  });
  return tempObj;
};
const zh_CN_App = {
  MENU_GAME: 'PLATFORM',
  MENU_SUBSCRIBE: 'FAQ',
  MENU_SETTING: 'VIDEO',
  ...getLang(gameLang),
  ...getLang(gameLang, 'game'),
  ...getLang(addLang, 'add'),
  ...getLang(subscribeLang, 'subscribe'),
  ...getLang(settingLang, 'setting'),
  ...getLang(commonLang, 'common'),
  //... ...
};
export default zh_CN_App;
